import styled from 'styled-components';

export const TankDetailsMain = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
`;

export const TankDetail = styled.div`
  border: 1px solid;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const TankDetailRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  border-bottom: ${props => (props.isLastRow ? '0' : '1px solid #e3e3e3')};
  padding: 0.5rem;
`;

export const TankDetailRowKey = styled.div`
  background-color: #f3f3f3;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TankDetailRowHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1rem;
`;
